export const supportChain = import.meta.env.VITE_SUPPORT_CHAIN || "56";
export const EXPLORER_SCAN_URL = import.meta.env.VITE_EXPLORER || "https://bscscan.com";
export const MARKET_ADDRESS = import.meta.env.VITE_MARKET_ADDRESS!;
export const MARKET_ADDRESS_NEW = import.meta.env.VITE_MARKET_ADDRESS_NEW!;
export const MARKET_FEATURE_ADDRESS = import.meta.env.VITE_MARKET_FEATURE_ADDRESS!;
export const OPV_ADDRESS = import.meta.env.VITE_OPV_ADDRESS!;
export const FACTORY_ADDRESS = import.meta.env.VITE_FACTORY_ADDRESS!;
export const MULTIL_FACTORY_ADDRESS = import.meta.env.VITE_MULTIL_FACTORY_ADDRESS!;
export const AIRDROP_ADDRESS = import.meta.env.VITE_AIRDROP_ADDRESS!;
export const TRANSFER_ADDRESS = import.meta.env.VITE_TRANSFER_ADDRESS!;
export const EVENT_ADDRESS = import.meta.env.VITE_EVENT!;
export const AUCTION_ADDRESS = import.meta.env.VITE_AUCTION_ADDRESS!;
export const AUCTION_MULTIL_ADDRESS = import.meta.env.VITE_AUCTION_MULTIL_ADDRESS!;
export const AUCTION_MULTIL_SEC_ADDRESS = import.meta.env.VITE_AUCTION_MULTIL_SEC_ADDRESS!;
export const MARKETPLACE_ADDRESS = import.meta.env.VITE_MARKETPLACE_ADDRESS!;
export const VITE_API_HOST = import.meta.env.VITE_API_HOST!;
export const VITE_API_URL = import.meta.env.VITE_API_URL!;

// Missing environment variables from .env.development
export const MARKET_ADDRESS_OLD = import.meta.env.VITE_MARKET_ADDRESS_OLD!;
export const REF_ADDRESS = import.meta.env.VITE_REF_ADDRESS!;
export const USDT_ADDRESS = import.meta.env.VITE_USDT_ADDRESS!;
export const MBC_ADDRESS = import.meta.env.VITE_MBC_ADDRESS!;
export const ENT_ADDRESS = import.meta.env.VITE_ENT_ADDRESS!;
export const BUSD_ADDRESS = import.meta.env.VITE_BUSDT_ADDRESS!;
export const SYNC_FFB_ADDRESS = import.meta.env.VITE_SYNC_FFB_ADDRESS!;
export const SYNC_FFB_NAME = import.meta.env.VITE_SYNC_FFB_NAME!;
export const COLLECTION_FACTORY = import.meta.env.VITE_COLLECTION_FACTORY as string;
export const CREATE_COLLECTION_OWN_CONTRACT = import.meta.env?.VITE_CREATE_COLLECTION_OWN_CONTRACT as string;
export const OPV_PRICE_CONTRACT = import.meta.env.VITE_OPV_PRICE as string;
export const AUCTION_CONTRACT = import.meta.env.VITE_AUCTION_CONTRACT as string;
export const OPV_VESTING_CONTRACT_ADDRESS = import.meta.env.VITE_CONTRACT_VESTING as string;
export const OPV_VESTING_GRAPH_ENDPOINT = import.meta.env.VITE_GRAPH_VESTING as string;
export const LOTTERY_CONTRACT_ADDRESS = import.meta.env.VITE_LOTTERY_CONTRACT_ADDRESS as string;
export const SANH_COLLECTION_CONTRACT_ADDRESS =
  import.meta.env.VITE_SANH_COLLECTION_CONTRACT_ADDRESS?.toLowerCase() as string;
export const CLIENT_BASE_URL = import.meta.env.VITE_CLIENT_BASE_URL as string;
export const VITE_LUCKY_DRAW_CONTRACT_ADDRESS = import.meta.env.VITE_LUCKY_DRAW_CONTRACT_ADDRESS as string;
export const SWAP_SMCT_ADDRESS = import.meta.env.VITE_SWAP_SMCT_ADDRESS!;
export const ORACLE_ADDRESS = import.meta.env.VITE_ORACLE_ADDRESS!;
export const SANH_PURCHASE_ADDRESS = import.meta.env.VITE_SANH_PURCHASE_ADDRESS!;
export const SANH_MARKETPLACE_CONTRACT = import.meta.env.VITE_SANH_MARKETPLACE_CONTRACT!;
export const SPINNER_TIME = import.meta.env.VITE_SPINNER_TIME!;
export const SHOW_PRIZE_TIME = import.meta.env.VITE_SHOW_PRIZE_TIME!;
export const MODE = import.meta.env.VITE_MODE!;
export const APPROVAL_BUFFER_PERCENT = import.meta.env.VITE_APPROVAL_BUFFER_PERCENT || 10;

export const EMPTY_VALUE = "--";
export const CURRENCY = "MBC";
export const LINK_OPEN_METAMASK = import.meta.env.VITE_LINK_OPEN_METAMASK;
export const LINK_OPEN_TRUST = import.meta.env.VITE_LINK_OPEN_TRUST;
export const ADDRESS_CONTRACT_SWAP = import.meta.env.VITE_SWAP_TOKEN_ADDRESS || "";
export const OPV = import.meta.env.VITE_OPV_ADDRESS || "";

export const IS_DEV = MODE === "development";

export const CHAIN_PROVIDER_POLLING_INTERVAL = 5000;
export const CACHE_TTL = 8000;
export const PRICE_POLLING_INTERVAL = 1500;

export enum TokenCurrency {
  MBC = "MBC",
  USDT = "USDT",
}

export const CURRENCIES = [
  { value: TokenCurrency.USDT, label: "USDT" },
  { value: TokenCurrency.MBC, label: "MBC" },
];

export enum ChainNetwork {
  BEP20 = "BEP20",
  ERC20 = "ERC20",
  TRC20 = "TRC20",
}

export const NETWORKS = [
  { value: ChainNetwork.BEP20, label: "BEP20 (BSC)" },
  { value: ChainNetwork.ERC20, label: "ERC20 (Ethereum)" },
  // { value: ChainNetwork.TRC20, label: "TRC20 (Tron)" },
];

export const NETWORK_FEE = 0.005; // 0.5%
